"use client";

import * as React from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { useOrkestriaTheme } from "@/lib/theme";

type OrkestriaLogoMarkProps = {
  className?: string;
  /** Tamaño en px del lado del cuadro del logo (cuadrado). */
  size?: number;
  priority?: boolean;
};

const MARK_BY_THEME: Record<string, string> = {
  light: "/landing/orkestria-mark-dark.png",   // relleno oscuro → visible en bg claro
  dark:  "/landing/orkestria-mark-light.png",  // relleno azul claro → visible en bg oscuro
  night: "/landing/orkestria-mark-cream.png",  // relleno crema → visible en bg negro
};

/** Logo de marca adaptado al tema activo de Orkestria. */
export function OrkestriaLogoMark({
  className,
  size = 36,
  priority = false,
}: OrkestriaLogoMarkProps) {
  const { theme } = useOrkestriaTheme();
  const src = MARK_BY_THEME[theme] ?? MARK_BY_THEME.dark;

  return (
    <Image
      src={src}
      alt="Orkestria"
      width={size}
      height={size}
      className={cn("shrink-0 object-contain", className)}
      priority={priority}
      draggable={false}
    />
  );
}
